import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useTheme } from "@mui/material";

const CarouselComponent = ({ items }) => {
  const theme = useTheme()
  return (
    <Carousel
      showStatus={false}
      swipeable={true}
      autoPlay={true}
      width={"100%"}
      dynamicHeight
      showIndicators={false}
    >
      {items &&
        items.map((item, i) => (
          <Grid
            key={i}
            container
            direction="column"
            alignItems="center"
            spacing={3}
            textAlign="center"
            sx={{ width: "100%" }}
          >
            <Grid item>
              <Typography variant="h1" color='secondary'>{item.title}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle2" color={theme.palette.mode === 'dark' ? 'white' : 'black'} >{item.description}</Typography>
            </Grid>
          </Grid>
        ))}
    </Carousel>
  );
};

CarouselComponent.propTypes = {
  items: PropTypes.array.isRequired,
};

export default CarouselComponent;
